// extracted by mini-css-extract-plugin
export default {"logout_wrapper":"Logout_logout_wrapper__x20Tf"};